import { takeEvery, put, call, fork, all } from 'redux-saga/effects';
// import { v4 as uuidv4 } from 'uuid';
// import { UAParser } from 'ua-parser-js';
// import { DateTime } from "luxon";

import { Client } from '../utils/client';

import { setError } from './actions';

let lastAction = {};

export function* initSession(action) {
  // const { bizMode } = action;

  // let config = yield call(Client.get, process.env.REACT_APP_BOOTSTRAP_URL, null, {
  //   headers: {
  //     'x-api-key': process.env.REACT_APP_KEY
  //   }
  // });

  // Client.setBaseURL(config.api);

  // yield put(setConfig(config));

  // try {
  //   // Client.setKey(process.env.REACT_APP_KEY);
  //   // yield put(onLoadSuccess(finalChannelData, finalEpgData, packageData.data, deviceData));
  // } catch (error) {
  //   console.log(error);

  //   // yield put(setError('App Title', 'App Message description'));
  // }
}

export function* saveLog(action) {
  if (lastAction.type !== action.type) {
    if (action.type === 'error/retry_action') {
      yield put(setError(null));
      yield put(lastAction);
    }
  }

  if (!action.type.includes('error')) {
    lastAction = action;
  }
}

function* watchOnLoad() {
  // yield takeEvery(ON_LOAD, initSession);
}

function* watchAndLog() {
  yield takeEvery('*', saveLog);
}

export function* appSaga() {
  // yield fork(watchOnLoad);
  yield fork(watchAndLog);
}
